import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SocketMessageFE, SocketLog } from './../../services/socket.service';


@Component({
	selector: 'app-common-socket-logs',
	templateUrl: './common-socket-logs.component.html',
	styleUrls: ['./common-socket-logs.component.css']
})
export class CommonSocketLogsComponent implements OnInit, OnChanges {

	@Input() title = 'Logs';
	// Logs
	@Input() log: SocketLog;

	// Logs of current process
	public socketMsg: SocketMessageFE[] = [];
	//
	public disableView = true;
	//
	constructor() { }

	onLogsChange(data: SocketLog) {
		if (data) {
			this.socketMsg = data.socketMsg;
			// TODO
		}
		// if (!this.processId) {
		// 	for (const id of Object.keys(data)) {
		// 		if (data[id].isCurrent) {
		// 			this.processId = id;
		// 			break;
		// 		}
		// 	}
		// }
		// if (data[this.processId]) {
		// 	this.socketMsg = data[this.processId].socketMsg;
		// 	this.disableView = !data[this.processId].isFinished || data[this.processId].isError;
		// }
	}
	ngOnInit() {

	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.log && changes.log.currentValue) {
			this.onLogsChange(changes.log.currentValue);
		}
	}

}
